// Reusable image drop zone component
// Frontend developers can modify the visual appearance here

import React from "react";

interface DropZoneProps {
  preview: string | null;
  onDrop: (e: React.DragEvent) => void;
  onClick: () => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  mode: "hash" | "verify";
}

export function DropZone({
  preview,
  onDrop,
  onClick,
  inputRef,
  onFileSelect,
  mode,
}: DropZoneProps) {
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  return (
    <div
      className={`drop-zone ${preview ? "has-image" : ""}`}
      onClick={onClick}
      onDrop={onDrop}
      onDragOver={handleDragOver}
    >
      {preview ? (
        <img
          src={preview}
          alt={mode === "hash" ? "Selected" : "Verifying"}
          className="preview-image"
        />
      ) : (
        <div className="drop-zone-content">
          {mode === "hash" ? (
            <>
              <div className="drop-zone-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17,8 12,3 7,8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
              </div>
              <p className="drop-zone-title">Upload to Sign</p>
              <p className="drop-zone-subtitle">Drag & drop or click to browse</p>
            </>
          ) : (
            <>
              <div className="drop-zone-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                </svg>
              </div>
              <p className="drop-zone-title">Upload to Verify</p>
              <p className="drop-zone-subtitle">Drag & drop or click to browse</p>
            </>
          )}
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={onFileSelect}
        className="file-input-hidden"
      />
    </div>
  );
}
